module.exports = __webpack_public_path__ + "static/media/message-warning.760ae7d0.svg";